import {
    STRIPE_CREATE_PAYMENT_INTENT,
    STRIPE_CREATE_PAYMENT_INTENT_RESET,
    STRIPE_UPDATE_BILLING_ADDRESS, STRIPE_UPDATE_BILLING_ADDRESS_RESET,
    STRIPE_UPDATE_PAYMENT_INTENT,
    STRIPE_UPDATE_PAYMENT_INTENT_RESET
} from "../actions/stripe";

const initialState = {
    createPaymentIntentSuccess: null,
    createPaymentIntentError: null,
    updatePaymentIntentSuccess: null,
    updatePaymentIntentError: null,
    paymentIntentClientSecret: null,
    updateBillingAddressSuccess: null,
    updateBillingAddressError: null
};

export default function stripeReducer(state = initialState, action) {
    switch (action.type) {
        case STRIPE_UPDATE_BILLING_ADDRESS:
            return {
                ...state,
                ...(action.payload && action.payload.updateBillingAddressSuccess && {
                    updateBillingAddressSuccess: true,
                }),
                updateBillingAddressError: action.error
            };
        case STRIPE_UPDATE_BILLING_ADDRESS_RESET:
            return {
                ...state,
                updatePaymentIntentError: initialState.updateBillingAddressError,
                updateBillingAddressSuccess: initialState.updateBillingAddressSuccess,
            };
        case STRIPE_CREATE_PAYMENT_INTENT:
            return {
                ...state,
                ...(action.payload && action.payload.createPaymentIntentSuccess && {
                    createPaymentIntentSuccess: true,
                    paymentIntentClientSecret: action.payload.paymentIntentClientSecret,
                }),
                createPaymentIntentError: action.error
            };
        case STRIPE_CREATE_PAYMENT_INTENT_RESET:
            return {
                ...state,
                createPaymentIntentError: initialState.createPaymentIntentError,
                createPaymentIntentSuccess: initialState.createPaymentIntentSuccess,
            };
        case STRIPE_UPDATE_PAYMENT_INTENT:
            return {
                ...state,
                ...(action.payload && action.payload.updatePaymentIntentSuccess && {
                    updatePaymentIntentSuccess: true,
                }),
                updatePaymentIntentError: action.error
            };
        case STRIPE_UPDATE_PAYMENT_INTENT_RESET:
            return {
                ...state,
                updatePaymentIntentError: initialState.updatePaymentIntentError,
                updatePaymentIntentSuccess: initialState.updatePaymentIntentSuccess,
            };
        default:
            return state;
    }
}